import { render, staticRenderFns } from "./MegafonIncomingSetup.vue?vue&type=template&id=72e072c5"
import script from "./MegafonIncomingSetup.vue?vue&type=script&lang=js"
export * from "./MegafonIncomingSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports